import { compareStudentsByName } from '@utils/studentName';

export default function firstSort(arr, key) {
  const firstItem = arr[0];
  if (firstItem && ('first_name' in firstItem || 'last_name' in firstItem)) {
    // Students: order by last name, then first name (case-insensitive) via the
    // shared helper so every roster is ordered the same way.
    arr.sort(compareStudentsByName);
  } else if (firstItem) {
    arr.sort((a, b) => {
      const nameA = a?.[key]?.toUpperCase(); // ignore upper and lowercase
      const nameB = b?.[key]?.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });
  }
}
